import classNames from 'classnames';
import PropTypes from 'prop-types';

import LoaderSkeleton from '../../components/LoaderSkeleton';

import styles from './_index.module.scss';

const Legend = ({ className, isHorizontal, isUpdating, items }) => {
  if (isUpdating) {
    return (
      <LoaderSkeleton height={300}>
        <rect height="15" rx="2" ry="2" width="15" x="0" y="25" />
        <rect height="15" rx="2" ry="2" width="200" x="20" y="25" />
        <rect height="15" rx="2" ry="2" width="15" x="0" y="50" />
        <rect height="15" rx="2" ry="2" width="175" x="20" y="50" />
        <rect height="15" rx="2" ry="2" width="15" x="0" y="75" />
        <rect height="15" rx="2" ry="2" width="225" x="20" y="75" />
        <rect height="15" rx="2" ry="2" width="15" x="0" y="100" />
        <rect height="15" rx="2" ry="2" width="185" x="20" y="100" />
      </LoaderSkeleton>
    );
  }

  return (
    <ul
      className={classNames(styles['legend'], className, {
        [styles['is-horizontal']]: isHorizontal,
      })}
    >
      {items?.map((item, index) => {
        return (
          <li className={styles['legend-item']} key={`legend-item-${index}`}>
            <div style={{ backgroundColor: item?.color }} />
            <p>{item?.name}</p>
          </li>
        );
      })}
    </ul>
  );
};

Legend.defaultProps = {
  items: [],
};

Legend.propTypes = {
  className: PropTypes.string,
  isHorizontal: PropTypes.bool,
  isUpdating: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
};

export default Legend;
